/* global.css */

/* Default values for Android and others */
:root {
    font: -apple-system-body; /* Otherwise the font-size not growing with font-size preferences on iOS */
    font-size: 1rem;
}

#psi-sidebar {
    font-size: 1rem;
    -webkit-text-size-adjust: 100%; /* Prevent iOS from resizing text (portrait to landscape) */
}

/* Expands the tap/click area to at least 44x44px without affecting visual layout.
   The CSS equivalent of AccessiblePointerTarget for React Aria / CSS Modules components. */
.extendedClickArea {
    position: relative;
}
.extendedClickArea::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: max(100%, 44px);
    height: max(100%, 44px);
    transform: translate(-50%, -50%);
}

.noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Modern browsers */
}
